import BookingStatusLabelType from '@/shared/constants/booking/BookingStatusLabelType'
import BookingStatusMap from '@/shared/constants/booking/BookingStatusMap'

export default Object.freeze({
  mobileDimensions: { minWidth: 358, height: 140 },
  dimensions: { minWidth: 452, minHeight: 124 },
  bookingStatusMap: BookingStatusMap,
  labelStatus: { ...BookingStatusLabelType },
})
